











import { Component, Prop, Vue } from 'vue-property-decorator';
import { AllContactsBlockDto } from '@/api';
import ContactBlock from '@/views/cms/cmsref/ContactBlock.vue';

@Component({
  components: {ContactBlock},
})
export default class AllContactsBlock extends Vue {
  @Prop({required: true})
  public readonly model!: AllContactsBlockDto;

}
